"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogContainer = void 0;
const React = require("react");
const dateFormat = require("dateformat");
const fluxible_router_1 = require("fluxible-router");
const react_loading_skeleton_1 = require("react-loading-skeleton");
const BlogStore_1 = require("../stores/BlogStore");
const Entities_1 = require("../../backend/models/Entities");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const helper_1 = require("../helper");
class Blog extends React.Component {
    constructor(props) {
        super(props);
    }
    renderSkeletonCard() {
        return (React.createElement("div", { className: "item" },
            React.createElement("div", { className: "blog-card" },
                React.createElement("div", { className: "media-block" },
                    React.createElement(react_loading_skeleton_1.default, { height: 250 }),
                    React.createElement("div", { className: "post-date" },
                        React.createElement("span", { className: "day" },
                            React.createElement(react_loading_skeleton_1.default, { width: 30 })),
                        React.createElement("span", { className: "month" },
                            React.createElement(react_loading_skeleton_1.default, { width: 30 })))),
                React.createElement("div", { className: "post-info" },
                    React.createElement("ul", { className: "category" },
                        React.createElement("li", null,
                            React.createElement(react_loading_skeleton_1.default, { width: 80 }))),
                    React.createElement("h4", { className: "blog-item-title" },
                        React.createElement(react_loading_skeleton_1.default, { count: 2 }))))));
    }
    render() {
        const postsResult = this.props.postsResult || new Entities_1.PagingResult();
        const isLoading = !postsResult.results || postsResult.results.length === 0;
        return (React.createElement("section", { className: "pt-page pt-page-current", "data-id": "blog" },
            React.createElement("div", { className: "section-title-block" },
                React.createElement("h2", { className: "section-title" }, "Blog"),
                React.createElement("h5", { className: "section-description" }, "My Diary")),
            React.createElement("div", { className: "blog-masonry" },
                isLoading ? (
                // Show skeleton cards while loading
                Array.from({ length: 6 }).map((_, index) => (React.createElement(React.Fragment, { key: `skeleton-${index}` }, this.renderSkeletonCard())))) : (postsResult.results.map((post) => {
                    return (React.createElement("div", { key: post._id, className: "item" },
                        React.createElement("div", { className: "blog-card" },
                            React.createElement("div", { className: "media-block" },
                                React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug },
                                    (post.image && post.image.secure_url) ?
                                        React.createElement("img", { className: "post-image img-responsive", src: (0, helper_1.convertImageUrl)(addTransormation(post.image.secure_url)), alt: 'media' })
                                        : null,
                                    React.createElement("div", { className: "mask" }),
                                    React.createElement("div", { className: "post-date" },
                                        React.createElement("span", { className: "day" }, dateFormat(post.publishedDate, 'dd')),
                                        React.createElement("span", { className: "month" }, dateFormat(post.publishedDate, 'mmm'))))),
                            React.createElement("div", { className: "post-info" },
                                post.categories != null ?
                                    React.createElement("ul", { className: "category" }, post.categories.map((category) => React.createElement("li", { key: category.key },
                                        React.createElement(fluxible_router_1.NavLink, { href: '/blog?category=' + category.name }, category.name))))
                                    : null,
                                React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug },
                                    React.createElement("h4", { className: "blog-item-title" }, post.title))))));
                })),
                (postsResult.previous || postsResult.next) ?
                    React.createElement("ul", { className: 'pager' },
                        postsResult.previous ?
                            React.createElement("li", { className: 'previous' },
                                React.createElement(fluxible_router_1.NavLink, { href: '/blog?page=' + (this.props.page - 1) }, "\u2190 Older")) : null,
                        postsResult.next ?
                            React.createElement("li", { className: 'next' },
                                React.createElement(fluxible_router_1.NavLink, { href: '/blog?page=' + (this.props.page + 1) }, "Newer \u2192")) : null) : null)));
    }
}
class BlogContainer {
    constructor(request, result) {
        this.request = request;
        this.result = result;
    }
}
exports.BlogContainer = BlogContainer;
class BlogProps {
}
exports.default = (0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(Blog, [BlogStore_1.default], (context, props) => {
    return {
        postsResult: context.getStore(BlogStore_1.default).getPosts(),
        page: context.getStore(BlogStore_1.default).getPageNum(),
        request: context.getStore(BlogStore_1.default).getRequestData(),
    };
}));
function addTransormation(imageUrl) {
    return imageUrl
        .replace('image/upload/', 'image/upload/c_scale,h_375,q_80,w_800/');
    //.replace('jpg', 'webp');
}
